/**
 * Only allow in-app paths as post-login redirect targets.
 * Rejects absolute URLs and protocol-relative or backslash forms
 * ("//evil.com", "/\\evil.com") that browsers treat as another origin.
 */
export function safeRedirect(target: unknown, fallback = '/dashboard'): string {
  if (typeof target !== 'string' || !target.startsWith('/')) return fallback;
  if (target.startsWith('//') || target.includes('\\')) return fallback;
  return target;
}
